import React from "react";
import Title from "../components/Title";
import { assets } from "../assets/assets";
import NewsletterBox from "../components/NewsletterBox";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <div>
      <Helmet>
        <title>About Sahla Curtain Center | Premium Curtains & Installation in Kerala</title>
        <meta name="description" content="Discover Sahla Curtain Center, founded by Muthu Koya Thangal, 42nd descendant of the Prophet, offering premium curtains and expert installation in Kerala. Learn about our legacy, values, and commitment to quality." />
        <meta name="keywords" content="about Sahla Curtain Center, Muthu Koya Thangal, curtain store Kerala, premium curtains, curtain installation, home decor, Kalpakanchery, expert service, quality curtains, founder, descendants of prophet" />
        <link rel="canonical" href="https://sccstore.com/about" />
        {/* Open Graph */}
        <meta property="og:title" content="About Sahla Curtain Center | Premium Curtains & Installation in Kerala" />
        <meta property="og:description" content="Discover Sahla Curtain Center, founded by Muthu Koya Thangal, 42nd descendant of the Prophet, offering premium curtains and expert installation in Kerala. Learn about our legacy, values, and commitment to quality." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sccstore.com/about" />
        <meta property="og:image" content="https://sccstore.com/preview.jpg" />
        <meta property="og:site_name" content="Sahla Curtain Center" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Sahla Curtain Center | Premium Curtains & Installation in Kerala" />
        <meta name="twitter:description" content="Discover Sahla Curtain Center, founded by Muthu Koya Thangal, 42nd descendant of the Prophet, offering premium curtains and expert installation in Kerala." />
        <meta name="twitter:image" content="https://sccstore.com/preview.jpg" />
        <meta name="twitter:site" content="@sccstore" />
        {/* Social Profiles */}
        <meta property="og:see_also" content="https://www.instagram.com/sahlacurtaincenter/" />
        <meta property="og:see_also" content="https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/" />
        <meta property="og:see_also" content="https://www.youtube.com/@sahlacurtaincenter" />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Sahla Curtain Center",
            "description": "Discover Sahla Curtain Center, founded by Muthu Koya Thangal, 42nd descendant of the Prophet, offering premium curtains and expert installation in Kerala. Learn about our legacy, values, and commitment to quality.",
            "url": "https://sccstore.com/about",
            "image": "https://sccstore.com/preview.jpg",
            "founder": {
              "@type": "Person",
              "name": "Muthu Koya Thangal",
              "description": "Owner of Sahla Curtain Center, 42nd direct descendant of the Prophet Muhammad (peace be upon him), respected community leader in Kerala.",
              "sameAs": [
                "https://www.instagram.com/sahlacurtaincenter/",
                "https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/",
                "https://www.youtube.com/@sahlacurtaincenter"
              ]
            },
            "publisher": {
              "@type": "Organization",
              "name": "Sahla Curtain Center",
              "logo": {
                "@type": "ImageObject",
                "url": "https://sccstore.com/favicon.png"
              },
              "sameAs": [
                "https://www.instagram.com/sahlacurtaincenter/",
                "https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/",
                "https://www.youtube.com/@sahlacurtaincenter"
              ]
            }
          }
        `}</script>
      </Helmet>
      <div className="text-2xl text-center pt-8 border-t">
        <Title text1={"ABOUT"} text2={"US"} />
      </div>

      <div className="my-10 flex flex-col md:flex-row gap-16">
        <img
          className="w-full md:max-w-[450px]"
          src={assets.about_img}
          alt=""
        />

        <div className="flex flex-col justify-center gap-6 md:w-2/4 text-gray-600">
          <p>
            <b className="text-lg text-gray-800">Meet Our Founder</b><br/>
            <span className="font-semibold">Muthu Koya Thangal</span> is the proud owner and visionary behind Sahla Curtain Center. As the 42nd direct descendant of the Prophet Muhammad (peace be upon him), Muthu Koya Thangal brings a legacy of integrity, compassion, and service to the business. His family heritage is deeply rooted in the traditions of leadership and community service, and he continues to uphold these values in every aspect of the shop.
          </p>
          <p>
            Muthu Koya Thangal established Sahla Curtain Center in Kalpakanchery, Kerala, with a mission to provide premium curtains and expert installation services to homes across the region. Under his guidance, the shop has grown to become a trusted name, known for its commitment to quality, customer satisfaction, and ethical business practices. He is also a respected figure in the local community, actively supporting charitable initiatives and fostering a culture of excellence among his team.
          </p>
          <p>
            <b className="text-gray-800">Our Story</b><br/>
            At Sahla Curtain Center, we’ve been providing high-quality curtains and professional curtain installation services since 2000. What began as a passion has grown into a well-established business in Kalpakanchery, where we are proud to offer a diverse range of premium curtains to suit every home. Our expert team is dedicated to ensuring that every product we offer complements your space and meets your needs, whether you’re looking for a simple refresh or a complete home makeover.
          </p>
          <p>
            In addition to offering a wide selection of curtains, we also provide expert installation services to ensure your window treatments are flawlessly fitted. Our experienced installation team takes care of everything from precise measurements to professional mounting, guaranteeing that your curtains are hung perfectly. We understand that every detail counts when it comes to creating a stylish and functional space, and we’re here to make your vision a reality from start to finish.
          </p>
          <b className="text-gray-800">Our Mission</b>
          <p>
            Our mission is to enhance every home with stylish, high-quality curtains and expert installation services. We are committed to providing personalized solutions that cater to the unique needs of each customer, ensuring satisfaction at every step. By combining passion, craftsmanship, and exceptional customer service, we aim to be the go-to destination for premium curtains and flawless installations in Kalpakanchery and beyond. Our goal is to create beautiful, functional spaces where our customers can feel comfortable, confident, and proud of their surroundings.
          </p>
          <p>
            <b className="text-gray-800">Legacy & Values</b><br/>
            Sahla Curtain Center is more than just a business—it is a legacy of trust, quality, and service. Inspired by the values of our founder, we strive to treat every customer with respect and honesty, ensuring that your experience with us is both memorable and rewarding. We invite you to visit our store and discover the difference that tradition, expertise, and genuine care can make in your home.
          </p>
        </div>
      </div>

      <div className="text-xl py-4">
        <Title text1={"WHY"} text2={"CHOOSE US"} />
      </div>

      <div className="flex flex-col md:flex-row text-sm mb-20">
        <div className="border px-10 md:px-16 py-8 sm:py-20 flex flex-col gap-5">
          <b>Quality Assurance</b>
          <p className=" text-gray-600">
            We are dedicated to providing only the highest quality curtains and
            installation services. Every product we offer is carefully selected
            for its durability, design, and functionality, ensuring it meets our
            stringent standards. Our installation team is trained to handle each
            project with precision and care, guaranteeing a flawless fit and
            finish. We stand behind the quality of our products and services,
            striving to exceed customer expectations with every project. Your
            satisfaction is our priority, and we are committed to delivering
            lasting value and beauty to your home.
          </p>
        </div>

        <div className="border px-10 md:px-16 py-8 sm:py-20 flex flex-col gap-5">
          <b>Convenience</b>
          <p className=" text-gray-600">
            We prioritize your convenience at every step of the process, from
            product selection to installation. Our team works closely with you
            to provide personalized recommendations, ensuring you find the
            perfect curtains that complement your style and needs. With flexible
            scheduling and a commitment to timely service, we make it easy to
            transform your space without disruption. Our user-friendly processes
            and dedicated support team ensure a seamless experience, allowing
            you to focus on enjoying the end result—a beautifully adorned and
            functional space tailored just for you.
          </p>
        </div>

        <div className="border px-10 md:px-16 py-8 sm:py-20 flex flex-col gap-5">
          <b>Exceptional Customer Service</b>
          <p className=" text-gray-600">
            Our commitment to exceptional customer service is the foundation of
            our business. We believe in building lasting relationships by
            understanding your unique preferences and delivering tailored
            solutions. From the moment you contact us, our team is ready to
            assist with expert advice, timely responses, and personalized care.
            We ensure a smooth experience through clear communication,
            transparency, and a focus on your satisfaction. Every interaction is
            guided by our dedication to exceed your expectations, creating a
            seamless journey from consultation to completion. Your happiness is
            our success, and we take pride in being a trusted partner for your
            home improvement needs.
          </p>
        </div>
      </div>
      <NewsletterBox />
    </div>
  );
};

export default About;
